module.exports = __webpack_public_path__ + "img/Telegram.669b3c29.png";